import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const CollectorNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="collector" />;
};
